import React, { useState } from "react";
import { Button } from "components/Buttons";
import "./LoginCard.css";
import ShowToast from "components/ShowToast";
import APP_CONFIG, { MONEY_TRANSFER_ACTION } from "constants/app";
import { moneyTransferAction } from "service/Auth.services";
import { captureAvdm } from "utils/rdService";
import { useSession } from "hooks/useSession";

const LoginCardAirtel = ({
  handleSubmitAction,
  handleTransferAction,
  handleRefundAction,
  resetHandler,
  location
}) => {
  const [formData, setFormData] = useState({
    phone: "",
    name: "",
    username: "",
    otp: "",
    aadharnum:""
  });
  const [showOtpModal, setShowOtpModal] = useState(false);
const [otpValue, setOtpValue] = useState("");

  const {userid}  = useSession();
const [pidData, setpidData] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showNameSection, setShowNameSection] = useState(false);
  const [shouldShowCreateUser, setshouldShowCreateUser] = useState(false);


  console.log('object :>> ', {showOtpModal});

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    if (["phone", "otp"].includes(name)) {
      updatedValue = value.replace(/\D/g, "");
    }

    setFormData((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }

    if (name === "phone") {
      if (updatedValue.length === 10) {
        handlePhoneChange(updatedValue);
      } else {
        resetHandler();
        setShowNameSection(false);
        setshouldShowCreateUser(false);
      }
    }
  };

  const handlePhoneChange = async (phoneValue) => {
    try {
      const res = await handleSubmitAction(phoneValue);
      if (res.status) {
        setShowNameSection(true);
        setshouldShowCreateUser(false);
        ShowToast("Details fetched successfully!", "success");
        setFormData((prev) => ({
          ...prev,
          name: `${res?.data?.name}` || "",
        }));
      } else {
        resetHandler();
        setShowNameSection(false);
        setshouldShowCreateUser(true);
      }
    } catch (error) {
      console.error("handleSubmitAction failed", error);
      setShowNameSection(false);
      setshouldShowCreateUser(false);
    }
  };

async function createUser() {
  const _formData = new FormData();
  _formData.set("userid", userid);
  _formData.set("aadhar_num", formData.aadharnum);
  _formData.set("name", formData.username);
  _formData.set("xml_data", pidData);
  _formData.set("mobile", formData.phone);
  _formData.set("lat", location.lat);
  _formData.set("long", location.lng);

  const res = await moneyTransferAction(
    _formData,
    MONEY_TRANSFER_ACTION.VERIF_BENE // 👈 create user
  );

  if (!res || !res.status) {
    ShowToast(res?.message || "User creation failed", "danger");
    return;
  }

  ShowToast("OTP sent to registered mobile", "success");

  // 🔹 OPEN OTP MODAL
  setShowOtpModal(true);
}
async function submitOtp() {
  if (!otpValue || otpValue.length < 4) {
    ShowToast("Enter valid OTP", "danger");
    return;
  }

  const otpForm = new FormData();
  otpForm.set("userid", userid);
  otpForm.set("mobile", formData.phone);
  otpForm.set("otp", otpValue);
  otpForm.set("lat", location.lat);
  otpForm.set("long", location.lng);

  const res = await moneyTransferAction(
    otpForm,
    MONEY_TRANSFER_ACTION.VALIDATE_OTP
  );

  if (res?.status) {
    ShowToast("KYC completed successfully", "success");
    setShowOtpModal(false);
    resetHandler();
  } else {
    ShowToast(res?.message || "OTP verification failed", "danger");
  }
}


  const handleCapture = async () => {
    const response = await captureAvdm(formData.selectedDevice, "E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=");
    if (response.success) {
      setpidData(response.data);
      console.log("PID XML:", response.data);
    } else {
      alert("Error: " + response.error);
    }
  };
  const handleSubmit = (e) => {
  
    e.preventDefault();
     if (!pidData) {
      setErrors({ pidData: "Please scan your fingerprint first." });
      return;
    }
    setLoading(true);
    createUser();
    console.log("Login attempt with phone:", formData.phone);
    setLoading(false);
   
  };

  return (
    <div className="card">
      <div className="card-header">
        <h5>Login Now</h5>
      </div>
      <div className="card-body">
        <form onSubmit={handleSubmit} className="app-form mt-4">
          <div className="row">
            <div className="col-md-12">
              <div className="floating-form">
                <input
                  type="text"
                  name="phone"
                  id="phone"
                  className="form-control"
                  placeholder="Enter your Phone"
                  value={formData.phone}
                  onChange={handleChange}
                  disabled={loading}
                  maxLength={10}
                />
                <label className="form-label" htmlFor="phone">
                  Phone
                </label>
                {errors.phone && (
                  <div className="error-message">{errors.phone}</div>
                )}
              </div>
            </div>
          </div>

          {/* Section for New User (Add Beneficiary) */}
          <div className={shouldShowCreateUser ? "" : "d-none"}>
            <div className="row my-4">
              <div className="col-md-12">
                <div className="floating-form">
                  <input
                    type="text"
                    name="username"
                    className="form-control"
                    placeholder="Enter your Name"
                    value={formData.username}
                    onChange={handleChange}
                    disabled={loading}
                    id="username"
                  />
                  <label className="form-label" htmlFor="username">
                    Name
                  </label>
                  {errors.username && (
                    <div className="error-message">{errors.username}</div>
                  )}
                </div>
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-md-12">
                <div className="floating-form">
                  <input
                    type="text"
                    name="aadharnum"
                    className="form-control"
                    placeholder="Enter your aadhar num"
                    value={formData.aadharnum}
                    onChange={handleChange}
                    disabled={loading}
                    maxLength={12}
                    id="aadharnum"
                  />
                  <label className="form-label" htmlFor="otp">
                    Aadhar Num
                  </label>
                  {errors.aadharnum && (
                    <div className="error-message">{errors.aadharnum}</div>
                  )}
                </div>
              </div>
              <center className="mt-3">
          <button
            onClick={handleCapture}
            className="btn btn-outline-primary p-0"
            style={{ width: "80px", height: "80px" }}
            type="button"
            
          >
            <img
              src="../assets/images/service/scan.gif"
              alt="Gif Button"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </button>
          {errors.pidData && (
            <div className="text-danger mt-2">{errors.pidData}</div>
          )}
        </center>
            </div>
            <div className="row">
              <div className="col text-end">
                <Button type="submit">Complete KYC</Button>
              </div>
            </div>
          </div>

          {/* Section for Existing User (Transfer / Refund) */}
          <div className={showNameSection ? "" : "d-none"}>
            <div className="row my-4">
              <div className="col-md-12">
                <div className="floating-form">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Enter your Name"
                    value={formData.name}
                    onChange={handleChange}
                    disabled={loading}
                    maxLength={50}
                    id="name"
                  />
                  <label className="form-label" htmlFor="name">
                    Name
                  </label>
                  {errors.name && (
                    <div className="error-message">{errors.name}</div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="d-flex justify-content-between">
                <Button
                  onClick={() => {
                    handleTransferAction(formData.phone);
                  }}
                >
                  Transfer
                </Button>
                <Button onClick={handleRefundAction}>Refund</Button>
              </div>
            </div>
          </div>
        </form>
      </div>
    {showOtpModal && (
  <>
    {/* Backdrop */}
    <div className="modal-backdrop fade show"></div>

    {/* Modal */}
    <div
      className="modal d-block"
      tabIndex="-1"
      style={{ zIndex: 1055 }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Verify OTP</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => setShowOtpModal(false)}
            />
          </div>

          <div className="modal-body">
            <input
              type="text"
              className="form-control"
              placeholder="Enter OTP"
              value={otpValue}
              maxLength={6}
              onChange={(e) =>
                setOtpValue(e.target.value.replace(/\D/g, ""))
              }
            />
          </div>

          <div className="modal-footer">
            <Button onClick={submitOtp}>Verify OTP</Button>
          </div>
        </div>
      </div>
    </div>
  </>
)}


    </div>
  );
};

export default LoginCardAirtel;
